import { defineMessages } from 'react-intl';

const messages = defineMessages({
  cis_woman: {
    id: 'InfoPgi.cis_woman',
    defaultMessage: 'Cisgender woman'
  },
  cis_man: {
    id: 'InfoPgi.cis_man',
    defaultMessage: 'Cisgender man'
  },
  trans_woman: {
    id: 'InfoPgi.trans_woman',
    defaultMessage: 'Trans woman'
  },
  trans_man: {
    id: 'InfoPgi.trans_man',
    defaultMessage: 'Trans man'
  },
  travesti: {
    id: 'InfoPgi.travesti',
    defaultMessage: 'Travesti'
  },
  non_binary: {
    id: 'InfoPgi.non_binary',
    defaultMessage: 'Non-binary'
  },
  intersex: {
    id: 'InfoPgi.intersex',
    defaultMessage: 'Intersex'
  },
  other: {
    id: 'InfoPgi.other',
    defaultMessage: 'Other'
  },
  opt_out: {
    id: 'InfoPgi.opt_out',
    defaultMessage: 'Opt Out'
  }
});

/** Códigos de identidade de gênero gravados em applicant.pgi. */
export const GENDER_IDENTITY_MESSAGE_IDS = {
  A: messages.cis_woman.id,
  B: messages.cis_man.id,
  C: messages.trans_woman.id,
  D: messages.trans_man.id,
  E: messages.travesti.id,
  F: messages.non_binary.id,
  G: messages.intersex.id,
  H: messages.other.id,
  OPTOUT: messages.opt_out.id
};

export function getGenderIdentityMessageId(value) {
  if (!value || value === 'no' || value === '--') return null;

  return GENDER_IDENTITY_MESSAGE_IDS[value] || null;
}
